import React, { useState, useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Button, FormGroup, FormControl } from 'react-bootstrap';
import { trackPageView, trackEvent } from '../util/Analytics.jsx';
import Utils from '../util/Utils.jsx';

import { useStateValue } from '../context/state.jsx';
import { openAlert } from '../context/alert.js';
import { setTokenExpired } from '../context/token.js';
import { setLoginSucceeded } from '../context/loginSucceeded.js';

const SignInPage = () => {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');

	const [{ loginSucceeded, redirectURL }, dispatch] = useStateValue();

	useEffect(() => {
		trackPageView();
	}, []);

	const emailChange = e => {
		setEmail(e.target.value);
	};

	const passwordChange = e => {
		setPassword(e.target.value);
	};

	const doLogin = () => {
		trackEvent('account', 'click', 'sign in');
		const postData = {
			emailAddress: email,
			password
		};
		Utils.ajax(
			'login',
			postData,
			dispatch,
			result => {
				if (result.success) {
					Utils.allowAuth();
					localStorage.setItem('token', result.Token);
					dispatch(setTokenExpired(false));
					dispatch(setLoginSucceeded(true));
				} else {
					if (result.error.includes('not verified')) {
						dispatch(openAlert('Not Verified', result.error, [{
							text: 'Resend Verification Email',
							action: () => {
								const postData = { emailAddress: email };
								Utils.ajax(
									'resendVerification',
									postData,
									dispatch,
									result => {
										if (result.success) {
											dispatch(openAlert('Verification Email', 'Please check your email for a verification link!'));
										}
									}
								);
							}
						}, {
							text: 'Close',
							action: () => true
						}]));
					} else {
						dispatch(openAlert('Login Error', result.error));
					}
				}
			}
		);
	};

	if (loginSucceeded) {
		return (<Navigate to={redirectURL || '/app/'} replace />);
	}
	return (
		<div className="signInPage">
			<div className="pageContent">
				<h2>Sign In</h2>
				<div>
					<FormGroup className="loginForm">
						<div>
							<FormControl type="email" placeholder="Email" value={email} onChange={emailChange} />
						</div>
						<div>
							<FormControl type="password" placeholder="Password" value={password} onChange={passwordChange} />
						</div>
						<div><Button block bsStyle="primary" onClick={doLogin}>Sign In</Button></div>
						<div>
							<Link to='/signup'>
								<Button>
									<span className="glyphicon glyphicon-arrow-left leftGlyph"></span>
									No login?
								</Button>
							</Link>
							<Link to='/signinhelp/' className="floatRight">
								<Button bsStyle="danger">
									<span className="glyphicon glyphicon-question-sign rightGlyph"></span>
									Forgot Password &nbsp;
								</Button>
							</Link>
						</div>
					</FormGroup>
				</div>
			</div>
		</div>
	);
};

export default SignInPage;